import { Controller } from '@hotwired/stimulus'

export default class AccountLinksController extends Controller {
  static targets = [
    'newSuffixField',
    'existingSelect',
    'subsidiaryContent',
    'chevron',
  ]

  declare readonly newSuffixFieldTarget: HTMLElement
  declare readonly hasNewSuffixFieldTarget: boolean
  declare readonly existingSelectTarget: HTMLElement
  declare readonly hasExistingSelectTarget: boolean
  declare readonly subsidiaryContentTargets: HTMLElement[]
  declare readonly chevronTargets: HTMLElement[]

  private activeRow: HTMLElement | null = null

  expandSection(event: Event): void {
    const toggleElement = event.currentTarget as HTMLElement

    const link = toggleElement.querySelector(
      'a[data-turbo-stream]'
    ) as HTMLElement

    if (link) {
      const chevron = toggleElement.querySelector(
        '.fa-chevron-right'
      ) as HTMLElement

      if (chevron) {
        chevron.classList.remove('fa-chevron-right')
        chevron.classList.add('fa-spinner', 'fa-spin')
      }

      link.click()
    }
  }

  toggleSection(event: Event): void {
    const toggleElement = event.currentTarget as HTMLElement
    let nextSibling = toggleElement.nextElementSibling

    while (nextSibling && nextSibling.classList.contains('collapse-row')) {
      this.toggleVisibility(nextSibling as HTMLElement)
      nextSibling = nextSibling.nextElementSibling
    }

    const chevron = toggleElement.querySelector(
      '.fa-chevron-right, .fa-chevron-down'
    ) as HTMLElement

    this.toggleChevron(chevron)
  }

  toggleSubsidiary(event: Event): void {
    const toggleElement = event.currentTarget as HTMLElement
    const accountId = toggleElement.dataset.consolidationAccountId

    const subsidiaryContent = this.subsidiaryContentTargets.find(
      (el) => el.dataset.consolidationAccountId === accountId
    )

    const chevron = this.chevronTargets.find(
      (el) =>
        (el.closest('[data-consolidation-account-id]') as HTMLElement)?.dataset
          .consolidationAccountId === accountId
    )

    if (subsidiaryContent && chevron) {
      this.toggleVisibility(subsidiaryContent)
      this.toggleChevron(chevron)
    }
  }

  connect(): void {
    window.eventHub.$on('drawer:close', this.removeHighlight.bind(this))
  }

  disconnect(): void {
    window.eventHub.$off('drawer:close', this.removeHighlight.bind(this))
  }

  highlightRow(event: Event): void {
    const link = event.currentTarget as HTMLElement
    const row = link.closest(
      '[data-consolidation--account-links-target="subsidiaryRow"]'
    ) as HTMLElement

    if (!row) return

    if (this.activeRow) {
      this.activeRow.style.backgroundColor = ''
    }
    row.style.backgroundColor = '#FEFCE8'
    this.activeRow = row
  }

  removeHighlight(): void {
    if (this.activeRow) {
      this.activeRow.style.backgroundColor = ''
      this.activeRow = null
    }
  }

  closeDrawer(event: Event): void {
    event.preventDefault()

    // Emit event to close the drawer (this will trigger removeHighlight via event listener)
    window.eventHub.$emit('drawer:close', 'right')
  }

  toggleSuffixType(event: Event): void {
    const radio = event.target as HTMLInputElement
    const isExisting = radio.value === 'existing'

    if (this.hasExistingSelectTarget) {
      this.existingSelectTarget.classList.toggle('tw-hidden', !isExisting)
    }

    if (this.hasNewSuffixFieldTarget) {
      this.newSuffixFieldTarget.classList.toggle('tw-hidden', isExisting)
    }
  }

  private toggleVisibility(element: HTMLElement): void {
    element.classList.toggle('sf-hidden')
  }

  private toggleChevron(chevron: HTMLElement): void {
    if (!chevron) return

    const isRight = chevron.classList.contains('fa-chevron-right')

    if (isRight) {
      chevron.classList.remove('fa-chevron-right')
      chevron.classList.add('fa-chevron-down')
    } else {
      chevron.classList.remove('fa-chevron-down')
      chevron.classList.add('fa-chevron-right')
    }
  }
}
